import { Factory } from 'miragejs';

export default Factory.extend({
  provider: 'personio',
  status: 'initiated',
  lastSyncedAt: null,
  linkUrl: () => `https://example.org/my-kombo-iframe/${crypto.randomUUID()}`,
});
